"use client";

import type { ReactNode } from "react";

import useViewTracking from "@blueshift-ui/telemetry/dist/hooks/use-view-tracking";

type ViewTrackProps = {
  children?: ReactNode;
  label?: string;
};

export default function ViewTrack({ children, label }: ViewTrackProps) {
  useViewTracking({ action: "loaded", category: "page", label });
  return <>{children}</>;
}

